export const HttpMethod = /* @__PURE__ */ Object.freeze({
  DELETE: 'DELETE',
  GET: 'GET',
  PATCH: 'PATCH',
  POST: 'POST',
  PUT: 'PUT',
});
export type HttpMethod = (typeof HttpMethod)[keyof typeof HttpMethod];
